import React, { useEffect } from 'react';
import { useAuthentication } from '../../hooks';
import { useNavigate } from 'react-router-dom';
import { DropPage } from '../DropPage';

interface PrivateRouteProps {
  path?: string;
}

export const PrivateRoute = <P extends JSX.IntrinsicAttributes>(
  Component: React.ComponentType<P>,
) =>
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  function Comp({ path, ...props }: P & PrivateRouteProps) {
    const { auth } = useAuthentication();
    const navigate = useNavigate();

    useEffect(() => {
      const isUserSignedIn = auth.isUserSignedIn();
      if (!isUserSignedIn) {
        auth.getSession();
      }
    }, [auth]);

    if (auth.isUserSignedIn()) {
      if (!auth.isBasicUser()) {
        navigate('/UnAuthorized');
        return null;
      }

      return <Component {...(props as P)} />;
    }
    return <DropPage>Redirecting</DropPage>;
  };
